import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Form, Button, Col, Accordion, Card } from "react-bootstrap";
// Contexto
import { context } from "../../../contexto";

const FormCiviles = ({ defaultValues, submissionHandler }) => {
  const [validated] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  // On submit del formulario
  const onSubmit = (data) => {
    //console.log(data)
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="departmentNumber-comunidad">
          <Form.Label>{"Número de Registro Ministerial **"}</Form.Label>
          <Form.Control
            name="departmentNumber"
            placeholder={"Número"}
            type="text"
            isInvalid={errors?.departmentNumber}
            {...register("departmentNumber", {
              required: "Este campo es obligatorio",
              validate: {
                isInt: (value) => {
                  return Number.isInteger(parseInt(value)) ? true : "El valor debe ser un número entero";
                },
              },
            })}
          />
          <ErrorMessage errors={errors} name="departmentNumber" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
        <Form.Group as={Col} xs={12} md controlId="fiscalNumber-comunidad">
          <Form.Label>{"Número de Identificación Fiscal *"}</Form.Label>
          <Form.Control
            name="fiscalNumber"
            placeholder={"Número"}
            type="text"
            isInvalid={errors?.fiscalNumber}
            {...register("fiscalNumber", {
              required: "Este campo es obligatorio",
            })}
          />
          <ErrorMessage errors={errors} name="fiscalNumber" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="phone-comunidad">
          <Form.Label>{"Teléfono *"}</Form.Label>
          <Form.Control
            name="telephone"
            placeholder={"Número"}
            {...register("telephone", {
              required: "Este campo es obligatorio",
            })}
          />
        </Form.Group>
        <Form.Group as={Col} xs={12} md controlId="email-comunidad">
          <Form.Label>{"Email"}</Form.Label>
          <Form.Control
            name="email"
            placeholder={"Texto"}
            type="text"
            isInvalid={errors?.email}
            {...register("email", {
              maxLength: {
                value: 320,
                message: "El máximo de caracteres es 320",
              },
              pattern: {
                value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                message: "El campo debe ser un email",
              },
            })}
          />
          <ErrorMessage errors={errors} name="email" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
        </Form.Group>
        <Form.Group as={Col} xs={12} md controlId="contextId-comunidad">
          <Form.Label>{"Contexto"}</Form.Label>
          <Form.Control name="contextId" as="select" custom isInvalid={errors.contextId} {...register("contextId", { required: "Este campo es obligatorio" })}>
            {context
              ? Object.keys(context).map((contextKey, index) => (
                <option key={index} value={contextKey}>
                  {context[contextKey]}
                </option>
              ))
              : ""}
          </Form.Control>
        </Form.Group>

      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} xs={12} md controlId="address-comunidad">
          <Form.Label>{"Dirección"}</Form.Label>
          <Form.Control
            name="address"
            placeholder={"Dirección"}
            {...register("address", {
            maxLength: {
              value: 200,
              message: "El máximo de caracteres es 200",
            }}
            )}
          />
        </Form.Group>
      </Form.Row>

      <Form.Row>
        <Form.Group className="col-md-6" as={Col} xs={12} md controlId="ciudad-comunidad">
          <Form.Label>{"Ciudad / Provincia"}</Form.Label>
          <Form.Control
            name="city"
            placeholder={"Ciundad/Provincia"}
            {...register("city", {
              maxLength: {
                value: 150,
                message: "El máximo de caracteres es 150",
              }})}
          />
        </Form.Group>
        <Form.Group className="col-md-2" as={Col} xs={12} md controlId="postcode-comunidad">
          <Form.Label>{"C.P."}</Form.Label>
          <Form.Control
            name="postcode"
            placeholder={"CP"}
            {...register("postcode", {
              maxLength: {
                value: 25,
                message: "El máximo de caracteres es 25",
              }})}
          />
        </Form.Group>
        <Form.Group className="col-md-4" as={Col} xs={12} md controlId="pais-comunidad">
          <Form.Label>{"País"}</Form.Label>
          <Form.Control
            name="country"
            placeholder={"País"}
            {...register("country", {
              maxLength: {
                value: 90,
                message: "El máximo de caracteres es 90",
              }})}
          />
        </Form.Group>


      </Form.Row>

      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormCiviles;
